export default {
  categories: {
    shoes: 'Schuhe',
    hoodies: 'Hoodies / Pullover',
    tshirts: 'T-Shirts',
    jackets: 'Jacken',
    pants: 'Hosen / Shorts',
    headwear: 'Kopfbedeckungen',
    sets: 'Sets',
    underwear: 'Unterwäsche',
    jersey: 'Trikots',
    accessories: 'Accessoires',
    bags: 'Taschen',
    belts: 'Gürtel',
    perfumes: 'Parfums',
    other: 'Sonstiges',
  },
};